<div id="overlay" *ngIf="isLoading" class="loading-overlay">
	<div class="loading-spinner"><img src="/content/images/loading3.gif" width="80" height="80" alt="Loading..."/></div>
</div>
<div class="row claim-profile step-1" *ngIf="claimService.claimStep === 1">
	<div class="col center">
		<h1>A quick step to <span class="block bold">confirm your details</span></h1>
		<p class="mt70" *ngIf="canContinue">
			Confirming (or correcting) the email address we have for you is an important security step to protect you and your reputation. Click below to send a confirmation email.
		</p>
		<ng-container *ngIf="canContinue">
			<p class="existing-email mt40 mb40">
				Email address on record: {{signupModel.maskedEmail}}
			</p>
			<button class="btn primary" (click)="sendVerificationEmail()">Send Confirmation Email</button>
		</ng-container>
		<div class="form-group error-container" *ngIf="signupModel.emailAlreadyInUse">
			<small class="error">There is already an active account for this email.</small>
		</div>
		<div class="form-group error-container" *ngIf="signupModel.emailError">
			<small class="error">The email attached to this account is invalid.</small>
		</div>
		<div class="form-group error-container" *ngIf="bigtimeError">
			<small class="error">Incorrect values or parameters were passed.</small>
		</div>
		<small>If this is not your email address or for help claiming your profile you can <a (click)="openManualClaim(manualClaimModal)">manually approve your profile</a> with one of our team members.</small>
	</div>
</div>
<div class="row claim-profile step-2" *ngIf="claimService.claimStep === 2">
	<div class="col center">
		<h1>Your confirmation email <span class="block bold">is on it’s way</span></h1>
		<p class="mt70">
			You should receive your email in the next few minutes, where you can follow the link to continue claiming your Rankipedia profile.
		</p>
		<div class="form-group error-container" *ngIf="!claimResultModel.success">
			<small class="error">There was an issue sending the verification email. {{claimResultModel.msg}}</small>
		</div>
		<small>Didn't get the email? <a href="javascript:void" (click)="sendVerificationEmail()">Resend now</a></small>
	</div>
</div>
<ng-template #contactModal let-modal>
	<app-contact-us-dialog [additionalMessage]="contactUsMetaData" (closeEvent)="modal.close($event)"></app-contact-us-dialog>
</ng-template>
<ng-template #manualClaimModal let-modal>
	<app-manual-claim-profile-dialog (closeEvent)="modal.close($event)"></app-manual-claim-profile-dialog>
</ng-template>
